export default {
  mounted() {
    this.handleKeyPress = this.throttleFunction(this.handleKeyPress, 60)
    this.addKeyPressListener()
  },
  destroyed() {
    this.removeKeyPressListener()
  },
  methods: {
    addKeyPressListener() {
      window.addEventListener('keydown', this.handleKeyPress)
    },
    removeKeyPressListener() {
      window.removeEventListener('keydown', this.handleKeyPress)
    },
    async handleKeyPress(event) {
      if (this.disable360) return

      const noop = () => {}
      await (
        {
          ArrowLeft: this.handleLeftKey,
          ArrowRight: this.handleRightKey,
        }[event.key] || noop
      )()
    },
    handleRightKey() {
      this.animationFrames = [] // Cancel current animation
      this.frameNumber = this.getFrameNumber(this.frameNumber - 1)
    },
    handleLeftKey() {
      this.animationFrames = [] // Cancel current animation
      this.frameNumber = this.getFrameNumber(this.frameNumber + 1)
    },
  },
}
